export default {
  MESSAGE_TEMPLATES_PER_CATEGORY: '/api/templates/all/{category}',
  CREATE_MESSAGE_TEMPLATE: '/api/templates',
  DELETE_MESSAGE_TEMPLATE: '/api/templates/{id}',
  UPDATE_MESSAGE_TEMPLATE: '/api/templates/update/{id}',
  CREATE_INTERSTITIAL_TEMPLATE: '/api/interstitial/templates',
  DELETE_INTERSTITIAL_TEMPLATE: '/api/interstitial/templates/{id}',
  UPDATE_INTERSTITIAL_TEMPLATE: '/api/interstitial/templates/update/{id}',
  USER_INFO: '/api/validate/fuel?fuel={fuel}',
  VALIDATE_DE_TABLE: '/api/validate/de?fuel={fuel2token}&deName={deName}',
  GET_VALIDATION_COLUMNS: '/api/validate/de/columns?fuel={fuel2token}&key={key}&entry={entry}',
  SEND_SMS: '/api/sms',
  GET_REAL_PARAM_VALUES:
    '/api/validate/realvalues?fuel={fuel2token}&key={key}&propertyName={propertyName}&entry={entry}',
  WEB_PUSH_CREATE_CAMPAIGN: '/api/webpush/create',
  WEB_PUSH_UPDATE_CAMPAIGN: '/api/webpush/update',
  WEB_PUSH_STOP_CAMPAIGN: '/api/webpush/stop',
  SEND_INTERSTITIAL: '/api/interstitial/send',
  NATIVE_PUSH_CREATE_CAMPAIGN: '/api/nativepush/create',
  NATIVE_PUSH_UPDATE_CAMPAIGN: '/api/nativepush/update',
  SEND_WEB_PUSH: '/api/webpush/proofing',
  SEND_NATIVE_PUSH: '/api/native/proofing',
  XP_CAMPAIGN_INFO: '/api/webpush/{game}/info/{id}',
  SHORT_URL_CHECK_BRAND: '/api/url/check?url={brandName}',
  SEND_VIBER: '/api/viber/proofing',
  GET_GLOBAL_URLS: '/api/url/get/global',
  IN_APP_CREATE_CAMPAIGN: '/api/inapp/create',
  IN_APP_UPDATE_CAMPAIGN: '/api/inapp/update',
  SEND_IN_APP: 'api/inapp/proofing',
};
